import * as React from "react";
import Accordion, { AccordionProps } from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";

interface GenericAccordionProps extends AccordionProps {
  title: string;
  id?: string;
  rounded?: boolean;
}

const GenericAccordion: React.FC<GenericAccordionProps> = ({
  title,
  children,
  id,
  rounded = false,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Accordion
      disableGutters
      sx={{
        width: "100%",
        boxShadow: "none",
        borderBottom: `1px solid ${theme.palette.divider}`,
        "&:last-child": {
          borderBottom: "none",
        },
        borderRadius: rounded ? `${theme.nawy.radius.xl} !important` : "none",
      }}
      {...rest}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${id || "panel"}-content`}
        id={`${id || "panel"}-header`}
        sx={{
          paddingY: theme.nawy.spacing.md,

          "& .MuiAccordionSummary-content": {
            margin: 0,
            alignItems: "flex-start",
          },

          "& .MuiAccordionSummary-expandIconWrapper": {
            alignSelf: "flex-start",
          },

          "&.Mui-expanded": {
            minHeight: theme.nawy.spacing["3xl"],
          },
          color: theme.nawy.colors.semantic.text.primary,
          ...theme.nawy.typography.english.variants.body.lg.semibold,
        }}
      >
        <Typography
          component="span"
          sx={{
            ...theme.nawy.typography.english.variants.body.lg.semibold,
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: theme.nawy.spacing.md,
          paddingTop: 0,
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default GenericAccordion;
